<script>

	import { mapState, mapActions } from 'vuex'

	import './style.scss'

	export default {
		name: 'question',
		props: [
			'lastAsked',
			'frequency',
			'title',
			'question',
		],
		watch: {
			isLoggedIn(loginState) {
				return loginState;
			}
		},
		computed: {
			...mapState({
				'isLoggedIn': state => state.user.isLoggedIn,
				'restricted': state => state.user.restrictedQuestions,
			}),
			formattedTitle () {
				return _.startCase(_.replace(this.title, /-/g, ' '));
			},
			formattedLastAsked () {
				return _.startCase(_.replace(this.lastAsked, /-/g, ' '));
			}
		},
		methods: {
			...mapActions([
				'showModal'
			]),
			showQuestionModal(modalComponent, question, title) {
				this.$store.dispatch('setQuestion', { question, title })
				this.$store.dispatch('showModal', modalComponent)
			}
		}
	}

</script>

<template>
	<div :class='{ question: true, disabled: restricted === true }'>
		<a
			:class='"question-title"'
			@click='showQuestionModal("Question", question, formattedTitle)'>
			{{ formattedTitle }}
		</a>
		<div class='last-asked'>
			{{ formattedLastAsked }}
		</div>
		<div class='frequency'>
			{{ frequency }}
		</div>
	</div>
</template>


// WEBPACK FOOTER //
// src/components/Question/Question.vue